module.exports = __webpack_public_path__ + "files/2759fc79c861111da820df5830329119.svg";